import React from 'react';
import { Alert } from 'reactstrap';

const WebsiteNotificationBar = ({ children, isOpen, toggle }) => {
  return (
    isOpen && (
      <div
        style={{
          textAlign: 'center',
          backgroundColor: '#fff3cd',
          position: 'absolute',
          minHeight: 30,
          top: 0,
          right: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <Alert
          color="warning"
          isOpen={isOpen}
          toggle={toggle}
          style={{ marginBottom: 0, padding: '0.35rem 1.25rem' }}
        >
          <strong>{children}</strong>
        </Alert>
      </div>
    )
  );
};

export default WebsiteNotificationBar;
